import { IndustryType } from '../config/industry/industry-types.enum';
import { INDUSTRY_ENUM } from '../shared/enums/industry.enum';
import {
  FooterActionConfig,
  IndustryUiConfig,
  SearchDropdownConfig,
  TableColumnsConfig,
} from './industry-ui.model';

const industry4Table: TableColumnsConfig = {
  itemNameLabel: 'Product/Item Name',
  showSerialNo: false,
  showCode: true,
  showQuotation: true,
  showMapping: false,
  showVariants: false,
  showRedeem: true,
  industry: INDUSTRY_ENUM.RETAIL,
  showManufacturer: false,
};

const industry4Search: SearchDropdownConfig = {
  showMappingHint: false,
  showVariantHint: false,
};

// const industry4Summary: SummaryPanelConfig = {
//   showCESS: false,
//   showTransportCharge: false,
//   showLoyalty: false,
// };

const industry4FooterActions: FooterActionConfig[] = [
  {
    key: 'salesList',
    label: () => 'Sales List',
    shortcutKey: 'F2',
    icon: 'pi pi-history',
    styleClass: 'function-btn-active-green has-white-icon',
    order: 1,
    title: 'View transaction history',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F2'),
  },
  {
    key: 'salesReturn',
    label: () => 'Sales Return',
    shortcutKey: 'F3',
    icon: 'pi pi-sync',
    styleClass: 'function-btn-white has-blue-icon',
    order: 2,
    title: 'Sales return / exchange items',
    disabledWhen: (c) =>
      c.isQuotationMode || c.isDeleteMode || c.isOfferGroupMode,
    handler: (c) => c.handleEvent('F3'),
  },
  {
    key: 'holdReceipt',
    label: () => 'Hold Receipt',
    shortcutKey: 'F4',
    icon: 'pi pi-pause',
    styleClass: 'function-btn-white has-blue-icon',
    order: 3,
    title: 'Hold current receipt',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F4'),
  },
  {
    key: 'reset',
    label: () => 'Reset',
    shortcutKey: 'F5',
    icon: 'pi pi-refresh',
    styleClass: 'function-btn-white has-blue-icon',
    order: 4,
    title: 'Reset current cart',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F5'),
  },
  {
    key: 'resumeReceipt',
    label: () => 'Resume Receipt',
    shortcutKey: 'F6',
    icon: 'pi pi-play',
    styleClass: 'function-btn-white has-blue-icon',
    order: 5,
    title: 'Resume held receipt',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F6'),
  },
  {
    key: 'deleteItem',
    label: (c) => (c.isDeleteMode ? 'Exit Delete Mode' : 'Delete Item'),
    shortcutKey: 'F9',
    icon: 'pi pi-trash',
    styleClass: 'function-btn-white',
    order: 6,
    title: 'Toggle delete mode',
    disabledWhen: (c) => c.isQuotationMode,
    handler: (c) => c.handleEvent('F9'),
  },
  {
    key: 'cashManagement',
    label: () => 'Cash Management',
    shortcutKey: 'F11',
    icon: 'pi pi-wallet',
    styleClass: 'function-btn-white',
    order: 7,
    title: 'Open cash management',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.navigateToCashManagement(),
  },
  {
    key: 'denomination',
    label: () => 'Denomination',
    shortcutKey: 'F12',
    icon: 'pi pi-calculator',
    styleClass: 'function-btn-white',
    order: 8,
    title: 'Open denomination',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.navigateToDenomination(),
  },
];

const industry7FooterActions: FooterActionConfig[] = [
  {
    key: 'salesList',
    label: () => 'Sales List',
    shortcutKey: 'F2',
    icon: 'pi pi-history',
    styleClass: 'function-btn-active-green has-white-icon',
    order: 1,
    title: 'View transaction history',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F2'),
  },
  {
    key: 'salesReturn',
    label: () => 'Sales Return',
    shortcutKey: 'F3',
    icon: 'pi pi-sync',
    styleClass: 'function-btn-white has-blue-icon',
    order: 2,
    title: 'Sales return / exchange items',
    disabledWhen: (c) =>
      c.isQuotationMode || c.isDeleteMode || c.isOfferGroupMode,
    handler: (c) => c.handleEvent('F3'),
  },
  {
    key: 'holdReceipt',
    label: () => 'Hold Receipt',
    shortcutKey: 'F4',
    icon: 'pi pi-pause',
    styleClass: 'function-btn-white has-blue-icon',
    order: 3,
    title: 'Hold current receipt',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F4'),
  },
  {
    key: 'reset',
    label: () => 'Reset',
    shortcutKey: 'F5',
    icon: 'pi pi-refresh',
    styleClass: 'function-btn-white has-blue-icon',
    order: 4,
    title: 'Reset current cart',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F5'),
  },
  {
    key: 'resumeReceipt',
    label: () => 'Resume Receipt',
    shortcutKey: 'F6',
    icon: 'pi pi-play',
    styleClass: 'function-btn-white has-blue-icon',
    order: 5,
    title: 'Resume held receipt',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.handleEvent('F6'),
  },
  {
    key: 'deleteItem',
    label: (c) => (c.isDeleteMode ? 'Exit Delete Mode' : 'Delete Item'),
    shortcutKey: 'F9',
    icon: 'pi pi-trash',
    styleClass: 'function-btn-white',
    order: 6,
    title: 'Toggle delete mode',
    disabledWhen: (c) => c.isQuotationMode,
    handler: (c) => c.handleEvent('F9'),
  },
  {
    key: 'cashManagement',
    label: () => 'Cash Management',
    shortcutKey: 'F11',
    icon: 'pi pi-wallet',
    styleClass: 'function-btn-white',
    order: 7,
    title: 'Open cash management',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.navigateToCashManagement(),
  },
  {
    key: 'denomination',
    label: () => 'Denomination',
    shortcutKey: 'F12',
    icon: 'pi pi-calculator',
    styleClass: 'function-btn-white',
    order: 8,
    title: 'Open denomination',
    disabledWhen: (c) => c.isQuotationMode || c.isDeleteMode,
    handler: (c) => c.navigateToDenomination(),
  },
];

export const DEFAULT_INDUSTRY_UI_CONFIG: IndustryUiConfig = {
  industryId: IndustryType.RETAIL,
  name: 'General Retail (default)',
  table: industry4Table,
  search: industry4Search,
  //   summary: industry4Summary,
  footerActions: industry4FooterActions,
};

// ---------------------------------------------------------------------------
// Industry 14 — Variant / Mapping Retail (the 2nd screenshot: S.No, Code,
// Mapping, Variants columns + Gross/IGST/CESS/Transport/Loyalty totals).
//

const industry14Table: TableColumnsConfig = {
  itemNameLabel: 'Product/Item Name',
  showSerialNo: true,
  showCode: false,
  showQuotation: false,
  showMapping: true,
  showVariants: true,
  showRedeem: true,
  industry: INDUSTRY_ENUM.MOBILE,
};

const industry14Search: SearchDropdownConfig = {
  showMappingHint: true,
  showVariantHint: true,
};

// const industry14Summary: SummaryPanelConfig = {
//   showCESS: true,
//   showTransportCharge: true,
//   showLoyalty: true,
// };

// Mobile shop has the retail actions except Delete Item (F9), renumbered 1..n
const industry14FooterActions: FooterActionConfig[] = industry4FooterActions
  .filter((action) => action.key !== 'deleteItem')
  .map((action, i) => ({ ...action, order: i + 1 }));

export const INDUSTRY_UI_CONFIGS: Record<number, IndustryUiConfig> = {
  [IndustryType.RETAIL]: DEFAULT_INDUSTRY_UI_CONFIG,
  [IndustryType.MOBILE]: {
    industryId: IndustryType.MOBILE,
    name: 'Variant / Mapping Retail',
    table: industry14Table,
    search: industry14Search,
    // summary: industry14Summary,
    footerActions: industry14FooterActions,
  },
  // 7: Restaurant — category-grid UI. Shares same table/search config as Retail. Direct billing (no table management).
  [IndustryType.RESTAURANT]: {
    industryId: IndustryType.RESTAURANT,
    name: 'Restaurant',
    table: {
      itemNameLabel: 'Menu Item',
      showSerialNo: false,
      showCode: false,
      showMapping: false,
      showQuotation: true,
      showVariants: false,
      showRedeem: false,
      industry: INDUSTRY_ENUM.RESTAURANT,
    },
    search: {
      showMappingHint: false,
      showVariantHint: false,
    },
    footerActions: industry7FooterActions,
  },
  // 15: Pharmacy — same UI as Retail (80% retail parity). API routed via /v1/pharmacy/...
  [IndustryType.PHARMACY]: {
    industryId: IndustryType.PHARMACY,
    name: 'Pharmacy',
    table: {
      ...industry4Table,
      industry: INDUSTRY_ENUM.PHARMACY,
      showManufacturer: true,
    },
    search: industry4Search,
    footerActions: industry4FooterActions,
  },
};
